import type { DeepString } from "@/lib/i18n";

export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak katalogów potomnych do wyświetlenia.",
  readMore: "Dowiedz się więcej",
} as const;

export type CCompanyDigitalizationTranslations = DeepString<typeof pl>;
